import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-lib-fw-collapse-wrapper',
  templateUrl: './collapse-wrapper.component.html',
  styleUrls: ['./collapse-wrapper.component.scss'],
  imports: [NgbCollapse],
})
export class FormlyCollapseWrapperComponent extends FieldWrapper {
  public isCollapsed: boolean;

  public get getLabel() {
    return `${this.props.text} ${+this.key + 1}`;
  }

  public get valid() {
    return (this.formControl.dirty || this.formControl.touched) && this.formControl.valid;
  }

  public get invalid() {
    return (!this.form.pristine || this.formControl.dirty || this.formControl.touched) && !this.formControl.valid;
  }
}
